// นำเข้าฟังก์ชันสำหรับสร้าง store จาก Redux และ applyMiddleware สำหรับใช้งาน middleware
import { legacy_createStore as createStore, applyMiddleware } from 'redux';

// นำเข้าฟังก์ชันสำหรับสร้าง persist store จาก redux-persist
import { persistStore } from 'redux-persist';

// นำเข้า middleware thunk สำหรับจัดการ asynchronous actions
import thunk from 'redux-thunk';

// นำเข้า rootReducer ซึ่งเป็นการรวม reducers ต่างๆ
import rootReducer from './root-reducer';

// กำหนด middlewares ที่จะใช้ใน store
const middlewares = [thunk];

// สร้าง store โดยใช้ rootReducer และ applyMiddleware สำหรับเพิ่ม middleware
export const store = createStore(rootReducer, applyMiddleware(...middlewares));

// สร้าง persistor ซึ่งเป็นตัวจัดการการเก็บ state ของ store ไว้ใน storage เพื่อคงสถานะเมื่อเริ่มต้นแอปพลิเคชันใหม่
export const persistor = persistStore(store);

// ส่งออก store และ persistor ไปใช้งาน
export default { store, persistor };
